import { useContext } from 'react';
import { HouseholdRelationshipChartsDataContext } from '../contexts/HouseholdRelationshipChartsDataContext';

export const useHouseholdRelationshipChartsDataContext = () => {
    return useContext(HouseholdRelationshipChartsDataContext);
};
